<template>
    <div class="placeholder">
        <div class="league-name">
            {{ leagueName }}
        </div>
        <div
            v-for="event in eventListDisplay"
            v-if="!isCollapsed"
            v-bind:key="event.id"
            v-bind:style="{
                height: getPlaceHolderHeight(event),
            }"
        >
            {{ event.homeTeamName }}
            <br>
            {{ event.awayTeamName }}
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { toRefs } from '@vueuse/core';
    import { storeToRefs } from 'pinia';
    import { type PropType, computed } from 'vue';
    import { OddsDisplayContext } from '@/components/oddsDisplay/OddsDisplayContext';
    import { getMatchPlaceHolderHeight, getMoreMarketPlaceHolderHeight } from '@/components/oddsDisplay/oddsTableCalculation';
    import { getTranslated } from '@/core/lib/translationHelper';
    import type { IEvent } from '@/interface/IEvent';
    import { BetTypeGroup } from '@/interface/enum';
    import { useOddsDisplaySettingsStore } from '@/store/oddsDisplaySettingsStore';

    const props = defineProps({
        eventList: {
            type: Object as PropType<IEvent[]>,
            required: true,
        },
    });

    const { eventList } = toRefs(props);

    const { oddsDisplayMode } = storeToRefs(useOddsDisplaySettingsStore());

    const { isGroupCollapsed } = OddsDisplayContext.inject();
    const isCollapsed = isGroupCollapsed(props.eventList[0].id);

    const leagueName = getTranslated(props.eventList[0].league.name);

    const getPlaceHolderHeight = (event: IEvent) => {
        const matchPlaceHolderHeight = getMatchPlaceHolderHeight(oddsDisplayMode.value, event.isLive, event);
        const moreMarketPlaceHolderHeight = getMoreMarketPlaceHolderHeight(oddsDisplayMode.value, event, BetTypeGroup.Main);

        return `${matchPlaceHolderHeight + moreMarketPlaceHolderHeight}px`;
    };

    const eventListDisplay = computed(() => eventList.value.map(event => ({
        ...event,
        homeTeamName: getTranslated(event.homeTeam.name),
        awayTeamName: getTranslated(event.awayTeam.name),
    })));
</script>

<style lang="scss" scoped>
.placeholder {
    opacity: 0;
}
</style>
